import React from 'react'
import { TextField, InputAdornment } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import { useStyles } from './style'

export const InputSearch = ({
  value,
  onChange,
  name,
  placeholder = 'Pesquisar...',
  className,
  ...props
}) => {
  const classes = useStyles()

  return (
    <TextField
      className={`${classes.searchInput} ${className || ''}`}
      placeholder={placeholder}
      name={name}
      variant="outlined"
      type="search"
      value={value}
      onChange={onChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon aria-hidden="true" />
          </InputAdornment>
        )
      }}
      inputProps={{
        'aria-label': placeholder
      }}
      {...props}
    />
  )
}
